import CONTRATO_DEDUCCIONES from '@/graphql/querys/administracion/contratos/deducciones/contratoDeducciones.gql';

export default {
  apollo: {
    contratoDeducciones: {
      query: CONTRATO_DEDUCCIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    mixCalcularDeducciones() {
      if (!this.contratoDeducciones) return;
      this.estimacion.deducciones = this.contratoDeducciones
        .map(({ deduccion: { id, porcentaje } }) => ({
          idDeduccion: id,
          importe: this.$numberRoundDigits(((porcentaje / 100) * this.estimacion.importeNeto), 2),
        }));
    },
  },
  computed: {
    mixGetContratoDeducciones() {
      if (!this.contratoDeducciones) return [];
      return this.contratoDeducciones.map(({ deduccion: { id, porcentaje } }) => ({
        idDeduccion: id,
        importe: this.$numberRoundDigits(((porcentaje / 100) * this.estimacion.importeNeto), 2),
      }));
    },
    mixGetTotalContratoDeducciones() {
      if (!this.contratoDeducciones) return 0;
      return this.$ObjSumar(this.mixGetContratoDeducciones, 'importe');
    },
  },
};
